import * as PropTypes from 'prop-types';
import * as React from 'react';

import { IOfferHelper } from '../../../presenter';
import { IOffer } from '../../../types/offer';

import * as styles from './index.css';

export interface ILandAreaContext {
  offer: IOffer;
  offerHelper: IOfferHelper;
}

export class LandArea extends React.Component {
  public context: ILandAreaContext;

  public static contextTypes = {
    offer: PropTypes.object,
    offerHelper: PropTypes.object,
  };

  public render() {
    const offer = this.context.offerHelper;
    const isSuburban = offer.isSuburban();

    if (
      !isSuburban ||
      this.context.offer.category && this.context.offer.category.indexOf('land') >= 0
    ) {
      return null;
    }

    const landArea = isSuburban && offer.suburban.getLandArea();

    if (landArea) {
      return (
        <div className={styles['land-area']}>
          {`${landArea.charAt(0).toUpperCase()}${landArea.substring(1)}`}
        </div>
      );
    }

    return null;
  }
}
